<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <h1>{{ $t('menu.register-new-manager') }}</h1>
        <piaf-breadcrumb/>
        <div class="separator mb-5"/>
      </b-colxx>
    </b-row>

    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" :title="$t('menu.register-new-manager')">
          <template v-if="isLoad">
            <b-table
              head-variant="light"
              ref="general-table"
              class="vuetable"
              selectedVariant="primary"
              :current-page="currentPage"
              :per-page="perPage"
              :items="items"
              :fields="fields"
              primary-key="settingId"
              responsive
              show-empty>


              <template v-slot:head(selected)>
                <b-form-checkbox v-model="selectAll"></b-form-checkbox>
              </template>
              <template v-slot:cell(username)="row">
                <!--                <router-link :to="`register-detail/${row.item.username}`" class="cls_click">-->
                {{row.item.username}}
                <!--                </router-link>-->
              </template>
          <template v-slot:cell(registeredDate)="row">
                {{row.item.requestedDate.substr(0,10)}}
              </template>

              <template v-slot:cell(etc)="row">
                <!--                <b-button variant="primary" @click="confirmRegister(row.item)">승인</b-button>-->

                <b-button variant="primary" :to="`register-detail/${row.item.username}`">승인/불가</b-button>
              </template>
              <!--              <template v-slot:cell(selected)="row">-->
              <!--                <b-form-checkbox v-model="row.item.selected"></b-form-checkbox>-->
              <!--              </template>-->

              <template v-slot:empty>
                <h4 style="text-align:center">조회된 내용이 없습니다.</h4>
              </template>

            </b-table>


            <b-pagination v-if="lastPage > 1"
                          size="sm"
                          align="center"
                          :total-rows="total"
                          :per-page="perPage"
                          v-model="currentPage"
            >
              <template v-slot:next-text>
                <i class="simple-icon-arrow-right"/>
              </template>
              <template v-slot:prev-text>
                <i class="simple-icon-arrow-left"/>
              </template>
              <template v-slot:first-text>
                <i class="simple-icon-control-start"/>
              </template>
              <template v-slot:last-text>
                <i class="simple-icon-control-end"/>
              </template>
            </b-pagination>

            <!--            <div style="text-align: right">-->
            <!--              <b-button class="mb-1" @click="allConfirmRegister" variant="primary">일괄 승인처리</b-button>-->
            <!--            </div>-->

          </template>

          <template v-else>
            <div class="loading"></div>
          </template>

        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";

  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import '../../assets/css/custom/common.css'
  import {alignTableCenter} from '../../utils'
  import api from "../../constants/api";

  export default {
    components: {
      'v-select': vSelect,
    },
    props: [],
    data() {
      return {
        isLoad: false,
        currentPage: 1,
        perPage: 10,
        total: 0,
        lastPage: 0,
        pageSizes: [10, 20, 30],
        fields: [
          // {key: "settingId", label: "번호", ...alignTableCenter},
          {key: "username", label: "운영자 ID", ...alignTableCenter},
          {key: "fullName", label: "운영자 이름", ...alignTableCenter},
          {key: "phoneNumber", label: "전화번호", ...alignTableCenter},
          {key: "email", label: "이메일", ...alignTableCenter},
          {key: "registeredDate", label: "가입일", ...alignTableCenter},
          {key: "etc", label: "승인여부", ...alignTableCenter},
          // {key: 'selected', label: '', ...alignTableCenter}
        ],
        items: [],
      }
    },

    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },

    mounted() {
      this.searchData()
    },

    methods: {

      //가입신청조회 (관리자리스트조회 -> approved : false)
      searchData() {
        this.items = []

        this.isLoad = false
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.list)

        this.$http.get(reqURL, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            
            let _items = res.data.data.admins
            for(let i = 0; i < _items.length; i++) {

              if(_items[i].approved == false) {
                this.items.push(_items[i])
              }
            }
            this.isLoad = true

          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      },


      selectAll(chk) {
        this.items.forEach(v => {
          v.selected = chk
        })
      },

      //승인버튼클릭
      // confirmRegister(row) {
      // const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
      // const params = {}
      // this.$http.post(reqURL, params, {
      //   headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      // }).then(res => {
      //   if(res.data.code === "OK") {
      //     alert('승인처리 되었습니다.')
      //     this.items = this.items.filter(item => item.settingId !== row.settingId)
      //   } else {
      //     throw 400
      //   }
      // }).catch(err => {
      //   alert('승인처리 실패하였습니다.')
      // })
      // },


      denyRegister(row) {


        console.log(row)
        let msg = '승인 불가 처리 하시겠습니까?'

        if(confirm(msg)) {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.unregister)
          const params = {
            username: row.item.username
          }

          console.log(params)
          this.$http.post(reqURL, params, {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if(res.data.code === "OK") {
              alert('적용하였습니다.')
              this.$router.go(0)
            } else {
              throw 400
            }
          }).catch(err => {
            console.log(err)
            alert(err.response.data.message);
          })
        }



      },

    }//method

  }
</script>
